import { createAction, createErrorAction } from '@saucelabs/sl-util-redux';

import * as types from './types';


export const toggleTeamSelection = createAction(types.TOGGLE_TEAM_SELECTION);

export const getInitialTeamTableRequest = createAction(types.INITIAL_TEAM_TABLE.REQUEST);
export const getInitialTeamTableSuccess = createAction(types.INITIAL_TEAM_TABLE.SUCCESS);
export const getInitialTeamTableFailure = createErrorAction(types.INITIAL_TEAM_TABLE.FAILURE);

export const saveTableOffset = createAction(types.UPDATE_OFFSET);

export const moveTeamUsersRequest = createAction(types.TEAM_MOVE_USERS.REQUEST);
export const moveTeamUsersSuccess = createAction(types.TEAM_MOVE_USERS.SUCCESS);
export const moveTeamUsersFailure = createErrorAction(types.TEAM_MOVE_USERS.FAILURE);
